import React, { Component } from 'react';
import moment from 'moment';

import withAuthorization from '../components/withAuthorization';
import { db, realtimeDb, firebase } from '../firebase/firebase';
import { auth } from '../firebase/index.js';

import Modal from 'react-modal';
import { showSnackbar, showSnackbarWithType } from '../components/Snackbar.js';
import 'element-theme-default';
import RoleUtils from '../utils/RoleUtils';
import BundledEditor from '../components/BundledEditor';

class NewsEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newsEntries: [],
            toBeRemovedPostalcodes: [],
            initialPostalCodes: [],
            postalCodes: [],
            postalCodeInput: '',
            postcodeLabelText: '',
            postcodeText: '',
            workareas: [],
            showNewsDetailsModal: false,
            showPostalcodesModal: false,
            selectedNews: {
                id: null,
                timestamp: null,
                description: null,
                address: null,
                status: null,
                title: null,
                imageUrl: null,
                content: null,
                subject: null,
                uid: null,
                updatedAt: null,
                postalCodes: ["5571NX", "5571", "1234AB"]
            },
            labelMunicipality: '',
            lastSelectedNews: null,
        };
    }

    componentDidMount() {
        this.getMyWorkareas();

        const newsFromStorageAsString = localStorage.getItem('lastSelectedNews');
        const openPostcodesModal = localStorage.getItem('openPostalcodesModal') === 'true';
        let newsFromStorage = null;
        if (newsFromStorageAsString) {
            newsFromStorage = JSON.parse(newsFromStorageAsString);
            console.log('newsFromStorage', newsFromStorage);
            localStorage.removeItem('openPostalcodesModal');
            this.setState({ selectedNews: newsFromStorage, lastSelectedNews: newsFromStorage, labelMunicipality: newsFromStorage.labelMunicipality });

            if (openPostcodesModal) {
                this.setState({
                    showPostalcodesModal: true,
                    initialPostalCodes: newsFromStorage.postalCodes || [],
                    postalCodes: newsFromStorage.postalCodes || [],
                });
            }
        }
    }

    getMyWorkareas = async () => {
        const userData = await auth.getUserData();
        console.log(userData);
        this.setState({ userData, workareas: [] });
        const workareasRef = realtimeDb.ref(`/workareas/${userData.uid}`);

        workareasRef.on('value', (snapshot) => {
            let workareas = snapshot.val();
            console.log('Fetched workareas:', workareas);

            if (!workareas) {
                workareas = [];
            }
            const onlyPostalWorkAreas = workareas.filter(item => !item.geometry);
            this.setState({ workareas: onlyPostalWorkAreas });
        });
    }

    componentWillUnmount() {

    }

    closeModal = () => {
        this.setState({ infoModalOpen: false, commentModalOpen: false });
    }

    extendPostcode(postcode) {
        let extended = [];
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (let i = 0; i < 26; i++) {
            for (let j = 0; j < 26; j++) {
                extended.push(postcode + letters[i] + letters[j]);
            }
        }
        return extended;
    }

    render() {
        const { labelMunicipality, selectedNews } = this.state;

        let content = selectedNews.content || this.state.content;

        console.log(labelMunicipality)

        if (this.props.rootUserData && (!RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Wijkagent) && !RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Gemeente) && !RoleUtils.hasRole(this.props.rootUserData, RoleUtils.Roles.Administrator))) {
            return (
                <div className="container content">
                    <div className="alert alert-danger" role="alert">
                        Je hebt geen toegang tot deze pagina.
                    </div>
                </div>
            );
        }

        return (
            <div className="container logboek content" style={{ maxWidth: 1300 }}>
                <div className="card" style={{ backgroundColor: 'white', padding: '20px', borderRadius: '5px' }}>
                    <form>
                        <div className="form-group">
                            <label htmlFor="title">Titel</label>
                            <input
                                type="text"
                                className="form-control"
                                id="title"
                                placeholder="Titel"
                                value={this.state.selectedNews.title || ''}
                                onChange={(e) => this.setState({ selectedNews: { ...this.state.selectedNews, title: e.target.value } })}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="subject">Onderwerp</label>
                            <input
                                type="text"
                                className="form-control"
                                id="subject"
                                placeholder="Onderwerp"
                                value={this.state.selectedNews.subject || ''}
                                onChange={(e) => this.setState({ selectedNews: { ...this.state.selectedNews, subject: e.target.value } })}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="labelMunicipality">Gemeente naam (wordt hergebruik in Sjablonen)</label>
                            <input
                                type="text"
                                className="form-control"
                                id="labelMunicipality"
                                placeholder="Gemeente naam"
                                value={this.state.selectedNews.labelMunicipality || ''}
                                onChange={(e) => this.setState({ selectedNews: { ...this.state.selectedNews, labelMunicipality: e.target.value }, labelMunicipality: e.target.value })}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="postalCodes" style={{ marginRight: 10 }}>Postcodes</label>  <button type="button" className="btn btn-primary btn-outline" onClick={() => this.setState({ showPostalcodesModal: true, initialPostalCodes: this.state.selectedNews.postalCodes || [], postalCodes: this.state.selectedNews.postalCodes || [] })} style={{ marginRight: 6 }}>
                                Postcodes wijzigen ({this.state.selectedNews.postalCodes ? this.state.selectedNews.postalCodes.length : '0'})
                            </button>
                            {this.state.selectedNews.postalCodes && this.state.selectedNews.postalCodes.length > 0 ? (
                                <div className="postal-codes-list">
                                    {this.state.selectedNews.postalCodes.map((code, index) => (
                                        <span key={index} className="badge badge-primary" style={{ marginRight: '5px', fontSize: 13 }}>
                                            {code}
                                        </span>
                                    ))}
                                </div>
                            ) : (
                                <span className="badge badge-secondary">Geen postcodes toegevoegd</span>
                            )}
                        </div>
                        <div className="form-group">
                            <label htmlFor="content">Inhoud</label>
                            <br />
                            <span className="badge badge-info" style={{ fontSize: 14, marginBottom: 3 }}>TIP: Sleep afbeeldingen naar de inhoud om ze toe te voegen in de tekst.</span>
                            <BundledEditor
                                key={labelMunicipality}
                                tinymceScriptSrc='/tinymce/tinymce.min.js'
                                init={{
                                    height: 500,
                                    menubar: false,
                                    plugins: [
                                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                        'insertdatetime', 'media', 'table', 'preview', 'help', 'wordcount'
                                    ],
                                    toolbar: 'undo redo | blocks | table | ' +
                                        'bold italic forecolor | alignleft aligncenter ' +
                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                        'removeformat | link image | sjablonen',
                                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px } ' + 'img { max-width: 300px; height: auto; } ' +
                                        '.header { width: 100%; background-color: #dfe6ec; padding: 20px; margin: 10px 0; border-radius: 5px;text-align:center } ' +
                                        '.footer { width: 100%; background-color: #dfe6ec; padding: 20px; margin: 10px 0; border-radius: 5px; } ' +
                                        '.header h1 { margin: 0; color: #094984; } ',
                                    extended_valid_elements: 'h1[id|class],h2[id|class],h3[id|class],p[id|class]',
                                    setup: (editor) => {
                                        editor.ui.registry.addMenuButton('sjablonen', {
                                            text: 'Sjablonen',
                                            fetch: function (callback) {
                                                const items = [
                                                    {
                                                        type: 'menuitem',
                                                        text: 'Kopstuk',
                                                        onAction: function () {
                                                            editor.insertContent(`
                                                                <div class="header" style="width: 100%; background-color: #dfe6ec; padding: 20px; margin: 10px 0; border-radius: 5px;text-align:center">
                                                                    <h1 style="margin: 0; color: #094984;">Team Langstraat</h1>
                                                                    <p>Subtitel....</p>
                                                                </div>
                                                            `);
                                                        }
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'Kop - Woninginbraken',
                                                        onAction: function () {
                                                            editor.insertContent(`
                                                                <div class="header" style="width: 100%; background-color: #dfe6ec; padding: 20px; margin: 10px 0; border-radius: 5px;text-align:center">
                                                                    <h1 style="margin: 0; color: #094984;">Woninginbraken afgelopen week gemeente ${labelMunicipality}</h1>
                                                                    <p>op basis van gedane aangifte</p>
                                                                </div>
                                                            `);
                                                        }
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'Kop - Autoinbraken',
                                                        onAction: function () {
                                                            editor.insertContent(`
                                                                <div class="header" style="width: 100%; background-color: #dfe6ec; padding: 20px; margin: 10px 0; border-radius: 5px;text-align:center">
                                                                    <h1 style="margin: 0; color: #094984;">Auto inbraken afgelopen week gemeente ${labelMunicipality}</h1>
                                                                    <p>op basis van gedane aangifte</p>
                                                                </div>
                                                            `);
                                                        }
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'Kop - Ontvreemde voertuigen',
                                                        onAction: function () {
                                                            editor.insertContent(`
                                                                <div class="header" style="width: 100%; background-color: #dfe6ec; padding: 20px; margin: 10px 0; border-radius: 5px;text-align:center">
                                                                    <h1 style="margin: 0; color: #094984;">Ontvreemde voertuigen gemeente ${labelMunicipality}</h1>
                                                                </div>
                                                            `);
                                                        }
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'Kop - Fietsdiefstal',
                                                        onAction: function () {
                                                            editor.insertContent(`
                                                                <div class="header" style="width: 100%; background-color: #dfe6ec; padding: 20px; margin: 10px 0; border-radius: 5px;text-align:center">
                                                                    <h1 style="margin: 0; color: #094984;">Fietsdiefstal afgelopen week gemeente ${labelMunicipality}</h1>
                                                                    <p>op basis van gedane aangifte</p>
                                                                </div>
                                                            `);
                                                        }
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'Kop - Overlast meldingen',
                                                        onAction: function () {
                                                            editor.insertContent(`
                                                                <div class="header" style="width: 100%; background-color: #dfe6ec; padding: 20px; margin: 10px 0; border-radius: 5px;text-align:center">
                                                                    <h1 style="margin: 0; color: #094984;">Overlast meldingen afgelopen week gemeente ${labelMunicipality}</h1>
                                                                </div>
                                                            `);
                                                        }
                                                    },
                                                    {
                                                        type: 'menuitem',
                                                        text: 'Voetstuk',
                                                        onAction: function () {
                                                            editor.insertContent(`
                                                                <div class="footer" style="width: 100%; background-color: #dfe6ec; padding: 20px; margin: 10px 0; border-radius: 5px;">
                                                                    <p>District Hart van Brabant</p>
                                                                </div>
                                                            `);
                                                        }
                                                    }
                                                ];
                                                callback(items);
                                            }
                                        });
                                    }
                                }}
                                onEditorChange={(newValue, editor) => this.setState({ selectedNews: { ...this.state.selectedNews, content: newValue }, content: newValue })}
                                value={content || ''}
                            />
                        </div>
                        <div className="form-group">
                            <button
                                type="button"
                                className="btn btn-primary btn-outline"
                                onClick={() => {
                                    const { selectedNews } = this.state;
                                    if (!selectedNews.title || !selectedNews.content) {
                                        showSnackbarWithType('Titel en inhoud zijn verplicht.', 'warning');
                                        return;
                                    }

                                    const newsData = {
                                        ...selectedNews,
                                        timestamp: selectedNews.timestamp || firebase.database.ServerValue.TIMESTAMP,
                                        updatedAt: moment().format()
                                    };

                                    const newsKey = selectedNews.id || realtimeDb.ref('news').push().key;

                                    const postalCodes = selectedNews.postalCodes || [];
                                    const updatesWithPostalcodes = {};

                                    if (postalCodes.length === 0) {
                                        showSnackbarWithType('Voeg ten minste één postcode toe.', 'warning');
                                        return;
                                    }

                                    postalCodes.forEach((pc) => {
                                        if (pc.length === 4) {
                                            // postcode needs to be extended to all combinations of AA to ZZ - like 1234AA, 1234AB, ..., 1234ZZ
                                            const extendedPostcodes = this.extendPostcode(pc);
                                            extendedPostcodes.forEach(epc => {
                                                updatesWithPostalcodes[`${epc}/${newsKey}`] = firebase.database.ServerValue.TIMESTAMP;
                                            });

                                            updatesWithPostalcodes[`${pc}_mk/${newsKey}`] = firebase.database.ServerValue.TIMESTAMP;
                                        }

                                        updatesWithPostalcodes[`${pc}/${newsKey}`] = firebase.database.ServerValue.TIMESTAMP;
                                    });
                                    realtimeDb.ref(`news_by_postalcodes`).update(updatesWithPostalcodes);

                                    realtimeDb.ref('news/' + newsKey).set(newsData)
                                        .then(() => {
                                            showSnackbarWithType('Nieuws succesvol opgeslagen.', 'success');
                                            this.setState({ selectedNews: { ...newsData, id: newsKey } });
                                            this.props.history.push('/news');
                                        })
                                        .catch((error) => {
                                            console.error('Error saving news:', error);
                                            showSnackbarWithType('Er is een fout opgetreden bij het opslaan van het nieuws.', 'error');
                                        });
                                }
                                }
                            >
                                Opslaan
                            </button>
                            {this.state.selectedNews.id && (
                                <button
                                    style={{ marginLeft: 18 }}
                                    type="button"
                                    className="btn btn-primary btn-raised"
                                    onClick={() => {
                                        const { selectedNews } = this.state;

                                        const newsKey = selectedNews.id;

                                        let isPublished = selectedNews.isPublished || false;

                                        realtimeDb.ref('news/' + newsKey).update({ isPublished: !isPublished })
                                            .then(() => {
                                                showSnackbarWithType(`Artikel succesvol ${isPublished ? 'onzichtbaar gemaakt' : 'gepubliceerd'}.`, 'success');
                                                this.setState({ selectedNews: { ...this.state.selectedNews, isPublished: !isPublished } });
                                            })
                                            .catch((error) => {
                                                console.error('Error publishing news:', error);
                                                showSnackbarWithType('Er is een fout opgetreden bij het publiceren van het artikel.', 'error');
                                            });
                                    }}
                                >
                                    {this.state.selectedNews.isPublished ? 'Onzichtbaar maken' : 'Publiceren'}
                                </button>
                            )}

                        </div>
                    </form>
                </div>

                <Modal
                    className="Modal__Bootstrap modal-dialog modal-lg"
                    closeTimeoutMS={150}
                    isOpen={this.state.showPostalcodesModal}
                    onRequestClose={() => this.setState({ showPostalcodesModal: false })}
                    ariaHideApp={false}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Postcodes</h4>
                            <button type="button" className="close" onClick={() => this.setState({ showPostalcodesModal: false, initialPostalCodes: [], postalCodes: [] })}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only">Sluiten</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <span><strong>Huidige postcodes:</strong></span>
                            <div style={{ marginBottom: '1em' }}>
                                {this.state.postalCodes && this.state.postalCodes.length > 0 ? (
                                    this.state.postalCodes.map((code, index) => (
                                        <span key={index} className="badge badge-primary" style={{ marginRight: '5px', cursor: 'pointer', padding: '0.5em', border: '1px solid rgb(221, 221, 221)' }}>
                                            {code} <span style={{ backgroundColor: 'rgb(240, 240, 240)', position: 'relative', padding: '5px', right: '-6px', color: 'rgb(72, 72, 72)' }} onClick={() => {
                                                const updatedCodes = this.state.postalCodes.filter((_, i) => i !== index);
                                                this.setState({ postalCodes: updatedCodes, toBeRemovedPostalcodes: [...this.state.toBeRemovedPostalcodes, code] });
                                            }}>x</span>
                                        </span>
                                    ))
                                ) : (
                                    <span className="badge badge-secondary">Geen postcodes toegevoegd</span>
                                )}
                            </div>
                            <span><strong>Mijn opgeslagen werkgebieden - Enkel postcodes varianten</strong></span>
                            <div className="form-group" style={{ display: 'inline-flex', width: '100%', borderBottom: '1px solid #ddd', paddingBottom: '1em' }}>
                                <div className="werkgebieden-list">
                                    {this.state.workareas && this.state.workareas.length > 0 ? (
                                        <ul className="list-group">
                                            {this.state.workareas.map((item, index) => (
                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center" style={{ padding: 0 }}>
                                                    <span>{item.label && item.label + ":"} {item.postcodes && item.postcodes.map((code, index) => (
                                                        <span key={index} className="badge badge-primary" style={{ marginRight: '5px' }}>
                                                            {code}
                                                        </span>
                                                    ))}</span>
                                                    <button className="btn btn-primary btn-sm btn-outline" onClick={() => {
                                                        const updatedCodes = [...this.state.postalCodes, ...item.postcodes];
                                                        const uniqueCodes = [...new Set(updatedCodes)];
                                                        this.setState({ postalCodes: uniqueCodes });
                                                    }}>Toevoegen</button>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p>Geen werkgebieden gevonden.</p>
                                    )}
                                </div>
                            </div>
                            <p>Voer een postcode in (1234AB - letters optioneel voor kleiner bereik)</p>
                            <div className="form-group" style={{ display: 'inline-flex', width: '100%' }}>
                                <input type="text" style={{ maxWidth: '300px', marginRight: '12px' }} className="form-control" placeholder="1234AB" value={this.state.postalCodeInput} onChange={(e) => this.setState({ postalCodeInput: e.target.value })} />
                                <button type="button" className="btn btn-primary btn-outline" onClick={() => {
                                    const { postalCodes, postalCodeInput } = this.state;
                                    if (postalCodes.includes(postalCodeInput.trim())) {
                                        showSnackbarWithType('Deze postcode is al toegevoegd.', 'warning');
                                        return;
                                    } else if (postalCodeInput.trim() === '') {
                                        showSnackbarWithType('Voer een geldige postcode in.', 'warning');
                                        return;
                                    } else if (postalCodeInput.trim().length < 4 || postalCodeInput.trim().length > 6) {
                                        showSnackbarWithType('Postcode moet tussen de 4 en 6 karakters zijn.', 'warning');
                                        return;
                                    }

                                    if (postalCodeInput.trim() !== '') {
                                        this.setState({
                                            postalCodes: [...postalCodes, postalCodeInput.trim()],
                                            postalCodeInput: ''
                                        });
                                    }
                                }}>
                                    Voeg postcode toe
                                </button>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ postalCodes: this.state.initialPostalCodes || [], initialPostalCodes: this.state.lastSelectedNews ? this.state.lastSelectedNews.postalCodes || [] : [] })}>
                                    Reset
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showPostalcodesModal: false, initialPostalCodes: [], postalCodes: [] })}>
                                    Sluiten
                                </button>
                                <button type="button" className="btn btn-primary" onClick={() => {
                                    const { postalCodes } = this.state;
                                    this.setState({
                                        showPostalcodesModal: false,
                                        initialPostalCodes: [], postalCodes: [],
                                        selectedNews: {
                                            ...this.state.selectedNews,
                                            postalCodes: [...postalCodes]
                                        },
                                        postalCodeInput: ''
                                    });
                                }}>
                                    Opslaan
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }

    closeModal = () => {
        this.setState({ infoModalOpen: false, commentModalOpen: false });
    }
}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(NewsEdit);
